import waypoint from "jquery-waypoints/waypoints.js"
import TweenMax from "gsap"

//第一栏动画
$('.block1 .text').each(function(index, el) {
  TweenMax.from($(this),1,{alpha:0,scale:0,ease:Power3.easeOut},'+=0.2');
});

//第二栏 精选定制案例 动画
+(function(){
  var $linyuList = $('.jinxuan-list');
  var $lists = $linyuList.find('li');
  var tl = new TimelineLite({paused:true});
  var timeLines = [];
    
  function liAnimate($li){
    var $li = $($li);
    var tl = new TimelineLite();
    tl.from($li,0.5,{y:-40,alpha:0,ease:Power3.easeOut},"-=0.2");
    return tl;
  }

  $lists.each(function(){
    timeLines.push(liAnimate($(this)));
  });

  tl.add(timeLines,"stagger","start",0.1);
  $linyuList.waypoint({
    handler:function(direction){
      if(direction == "down"){
        tl.play();
      }else if(direction == "up"){
        tl.reverse();
      }
    },
    offset:'60%'
  });
})();

//第四栏联系我们 动画
+(function(){
  if(document.body.clientWidth>1200||document.body.clientWidth==1200){
    var $contacts = $('.contacts');
    var $items = $contacts.find('.item');
    var tl = new TimelineLite({paused:true});
    var timeLines = [];
      
    function itemAnimate($item){
      var $item = $($item);
      var $divs = $item.children('div');
      var tl = new TimelineLite();
      tl.from($item,0.5,{x:40,alpha:0,ease:Power3.easeOut},"-=0.1")
        .from($divs[0],0.5,{x:40,alpha:0,ease:Power3.easeOut},"-=0.1")
        .from($divs[1],0.5,{x:40,alpha:0,ease:Power3.easeOut},"-=0.1")
        .from($divs[2],0.5,{x:40,alpha:0,ease:Power3.easeOut},"-=0.1");
      return tl;
    }

    $items.each(function(){
      timeLines.push(itemAnimate($(this)));
    });

    tl.add(timeLines,"stagger","start",0.1);
    $contacts.waypoint({
      handler:function(direction){
        if(direction == "down"){
          tl.play();
        }else if(direction == "up"){
          tl.reverse();
        }
      },
      offset:'70%'
    });
  }
  
})();



// WEBPACK FOOTER //
// ./src/pages/base/aboutus.js